export default __webpack_public_path__ + "static/media/founder1.0e14cd5f.jpg";